// Requires WordPress jQuery, not webpack because that's what Solr's listerners are attatched to.
// import $ from 'jquery';

const $searchFacetBox = window.jQuery('#solr_facet');
const $submit = $searchFacetBox.find('[type="submit"]');

window.jQuery(`<a href="?" class="disney-search-reset">Reset</a>`).insertAfter($submit);
window.jQuery('.solr-facet ul li').wrapInner('<label></label>');

window.jQuery(document).ready(() => {
	// Use setTimeout to ensure this runs in the JS event loop processed directly AFTER doc ready where the
	// plugin listeners are set.
	setTimeout(() => {
		window.jQuery('body').off('change', '#solr_s');
	}, 0);
});


// WEBPACK FOOTER //
// ./src/layout/partials/solr_search_facetss.js